export default {
    chart: {
        type: 'line'
    },
    yAxis: {
        labels: {
            format: '{value} °C'
        }
    },
    tooltip: {
        valueSuffix: '°C'
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/temperature.js